<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-6xl">
    <div class="mb-8 flex items-end justify-between gap-4">
      <div>
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Your pools</span
        >
        <h1 class="font-display text-3xl font-semibold text-parchment">My Competitions</h1>
      </div>
      <a
        routerLink="/competitions/new"
        class="inline-flex shrink-0 items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-5 py-2.5 text-sm font-bold text-ink transition hover:-translate-y-px"
        >+ New</a
      >
    </div>

    @if (loading()) {
      <p class="text-dusk">Loading…</p>
    } @else if (errorMessage()) {
      <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
        {{ errorMessage() }}
      </p>
    } @else if (owned().length === 0 && joined().length === 0) {
      <div class="rounded-md border border-hairline bg-panel p-9 text-center">
        <p class="text-dusk">You haven't created a competition yet.</p>
        <a
          routerLink="/competitions/new"
          class="mt-5 inline-flex items-center justify-center rounded-[3px] border border-hairline px-6 py-3 text-sm font-semibold text-parchment transition hover:border-parchment"
          >Create your first one</a
        >
      </div>
    } @else {
      @if (owned().length > 0) {
        <h2 class="mb-3 text-xs font-semibold uppercase tracking-wide text-dusk">
          Competitions you own
        </h2>
        <ul class="grid gap-4 lg:grid-cols-2">
          @for (c of owned(); track c.id) {
            <li>
              <ng-container
                *ngTemplateOutlet="competitionCard; context: { $implicit: c, showAdminBadge: false }"
              />
            </li>
          }
        </ul>
      } @else {
        <p class="text-sm text-dusk">
          You haven't created a competition yet —
          <a routerLink="/competitions/new" class="text-gold hover:underline">create one</a>.
        </p>
      }

      @if (joined().length > 0) {
        <h2 class="mb-3 mt-8 text-xs font-semibold uppercase tracking-wide text-dusk">
          Competitions you're in
        </h2>
        <ul class="grid gap-4 lg:grid-cols-2">
          @for (c of joined(); track c.id) {
            <li>
              <ng-container
                *ngTemplateOutlet="competitionCard; context: { $implicit: c, showAdminBadge: isSiteAdmin() }"
              />
            </li>
          }
        </ul>
      }
    }

    <ng-template #competitionCard let-c let-showAdminBadge="showAdminBadge">
      <a
        [routerLink]="['/competitions', c.id]"
        class="block h-full rounded-md border border-hairline bg-panel p-6 transition hover:border-gold"
      >
        <div class="flex items-start justify-between gap-4">
          <div>
            <div class="flex items-center gap-2">
              <h3 class="font-display text-xl font-semibold text-parchment">{{ c.name }}</h3>
              @if (c.ownerIsSiteAdmin && showAdminBadge) {
                <span
                  class="shrink-0 rounded-full border border-dusk px-2 py-0.5 text-[0.65rem] font-semibold uppercase tracking-wide text-dusk"
                  >Admin-owned</span
                >
              }
            </div>
            <p class="mt-1 text-sm text-dusk">
              {{ dateOnly(c.startDate) }} – {{ dateOnly(c.endDate) }}
            </p>
          </div>
          <span
            class="shrink-0 rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-wide"
            [class.border-gold]="c.status === 'ACTIVE'"
            [class.text-gold]="c.status === 'ACTIVE'"
            [class.border-wax-bright]="c.status === 'ON_HOLD'"
            [class.text-wax-bright]="c.status === 'ON_HOLD'"
            >{{ c.status === 'ACTIVE' ? 'Active' : 'On hold' }}</span
          >
        </div>
        <p class="mt-4 font-mono text-sm text-dusk">
          Invite code: <span class="text-parchment">{{ c.shortCode }}</span>
        </p>

        <div class="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-hairline pt-4 text-sm">
          <span class="text-dusk">{{ submissionStatus(c) }}</span>
          <span class="font-semibold text-gold">{{ totalPointsFor(c) }} pts</span>
        </div>

        @if (financialAwardsFor(c).length > 0) {
          <p class="mt-2 text-xs text-dusk">
            Winnings: <span class="text-parchment">{{ financialAwardsFor(c).join(', ') }}</span>
          </p>
        }

        @if (recentAchievementsFor(c).length > 0) {
          <ul class="mt-2 flex flex-col gap-0.5 text-xs text-dusk">
            @for (award of recentAchievementsFor(c); track award.awardId) {
              <li>
                @if (award.personName) {
                  <span class="text-parchment">{{ award.personName }}</span> —
                }
                {{ award.name }}
                ({{ awardValue(award) }})
              </li>
            }
          </ul>
        }
      </a>
    </ng-template>
  </div>
</section>
